module.exports = __webpack_public_path__ + "auMade.webp?c75493ec25446d85657bb6bef8076337";